function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { AuthBase } from "../../../plunk/service/auth-base";
import endpoints from "../../endpoints";

/*
 * Customer add/edit (CUSTOMERS_SECTION.md Phase 3, manual CRUD).
 * Create: POST /v1/lifecycle/customers ; Edit: PUT /v1/lifecycle/customers/{id}
 * (LifecycleCustomerController, CustomerWriteModel). Raw bearer fetch: the 409
 * duplicate-guard body (email / customer_number) surfaces inline.
 */
const f = (row, key) => {
  if (!row) return "";
  if (row[key] !== undefined && row[key] !== null) return row[key];
  const pascal = key.charAt(0).toUpperCase() + key.slice(1);
  return row[pascal] != null ? row[pascal] : "";
};

// Layout and look: .pcm-* in sass/v2/_people-customers.scss (People redesign 2026-10-09).
const sameAddress = st => !st.shipToCity && !st.shipToRegion && !st.shipToPostalCode;
export default class CustomerModal extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "save", async () => {
      const s = this.state;
      if (!s.name.trim()) {
        this.setState({
          error: "Name is required."
        });
        return;
      }
      this.setState({
        saving: true,
        error: ""
      });
      const body = {
        name: s.name.trim(),
        customerNumber: s.customerNumber.trim() || null,
        customerType: s.customerType,
        lifecycleChannel: s.lifecycleChannel,
        lifecycleStage: s.lifecycleStage || null,
        email: s.email.trim() || null,
        phone: s.phone.trim() || null,
        billToCity: s.billToCity || null,
        billToRegion: s.billToRegion || null,
        billToPostalCode: s.billToPostalCode || null,
        shipToCity: (s.sameShip ? s.billToCity : s.shipToCity) || null,
        shipToRegion: (s.sameShip ? s.billToRegion : s.shipToRegion) || null,
        shipToPostalCode: (s.sameShip ? s.billToPostalCode : s.shipToPostalCode) || null
      };
      if (body.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(body.email)) {
        this.setState({
          saving: false,
          error: "That email address doesn't look right."
        });
        return;
      }
      if (body.name.includes("@")) {
        this.setState({
          saving: false,
          error: "Use the business or person's name here. The email goes in the Email box."
        });
        return;
      }
      const editId = this.props.customer ? f(this.props.customer, "id") : null;
      const url = editId ? `${endpoints.product.root}/lifecycle/customers/${encodeURIComponent(String(editId))}` : `${endpoints.product.root}/lifecycle/customers`;
      try {
        const res = await fetch(url, {
          method: editId ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + (AuthBase.idToken || "")
          },
          body: JSON.stringify(body)
        });
        if (res.status === 409) {
          let m = "A customer with that email or customer number already exists.";
          try {
            const b = await res.json();
            if (b && b.error) m = b.error;
          } catch (e) {/* keep default */}
          this.setState({
            saving: false,
            error: m
          });
          return;
        }
        if (!res.ok) throw new Error(`Save failed (${res.status})`);
        this.setState({
          saving: false
        });
        this.props.onSaved && this.props.onSaved();
      } catch (e) {
        this.setState({
          saving: false,
          error: e.message || "Save failed."
        });
      }
    });
    const c = props.customer || null;
    this.state = {
      saving: false,
      error: "",
      name: f(c, "name"),
      customerNumber: f(c, "customerNumber"),
      customerType: f(c, "customerType") || "business",
      lifecycleChannel: f(c, "lifecycleChannel") || "b2b",
      lifecycleStage: f(c, "lifecycleStage"),
      email: f(c, "email"),
      phone: f(c, "phone"),
      billToCity: f(c, "billToCity"),
      billToRegion: f(c, "billToRegion"),
      billToPostalCode: f(c, "billToPostalCode"),
      shipToCity: f(c, "shipToCity"),
      shipToRegion: f(c, "shipToRegion"),
      shipToPostalCode: f(c, "shipToPostalCode")
    };
    this.state.sameShip = sameAddress(this.state);
    // Dealers are always businesses that buy wholesale: no person / shopper choices on dealer workspaces.
    if (props.dealers) {
      this.state.customerType = "business";
      this.state.lifecycleChannel = "b2b";
    }
  }
  field(label, key, opts = {}) {
    const id = `pcm-${key}`;
    return /*#__PURE__*/React.createElement("div", {
      className: "pcm-field" + (opts.wide ? " wide" : "")
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: id
    }, label, opts.optional ? /*#__PURE__*/React.createElement("span", {
      className: "pcm-opt"
    }, " (optional)") : null), opts.options ? /*#__PURE__*/React.createElement("select", {
      id: id,
      value: this.state[key],
      onChange: e => this.setState({
        [key]: e.target.value,
        error: ""
      })
    }, opts.options.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l))) : /*#__PURE__*/React.createElement("input", {
      id: id,
      type: opts.type || "text",
      value: this.state[key],
      placeholder: opts.placeholder || "",
      autoFocus: !!opts.autoFocus,
      onChange: e => this.setState({
        [key]: e.target.value,
        error: ""
      })
    }));
  }
  render() {
    const s = this.state;
    const editing = !!this.props.customer;
    const dealers = !!this.props.dealers;
    const noun = this.props.noun || (dealers ? "dealer" : "customer");
    const close = () => {
      if (!s.saving) this.props.onClose();
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "pcm-overlay",
      onClick: e => {
        if (e.target === e.currentTarget) close();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-card",
      role: "dialog",
      "aria-labelledby": "pcm-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pcm-titles"
    }, /*#__PURE__*/React.createElement("h2", {
      id: "pcm-title"
    }, editing ? `Edit ${noun}` : `Add a ${noun}`), /*#__PURE__*/React.createElement("span", null, editing ? "Changes show everywhere this account appears." : dealers ? "A business that sells your products. Orders and contacts link to it automatically." : "A business or person you sell to. Orders and contacts link to it automatically.")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pcm-x",
      "aria-label": "Close",
      onClick: close
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "close"))), dealers ? /*#__PURE__*/React.createElement("div", {
      className: "pcm-grid pairs"
    }, this.field("Business name", "name", {
      placeholder: "For example: Northside Supply",
      wide: true,
      autoFocus: !editing
    }), this.field("Customer number", "customerNumber", {
      optional: true
    }), this.field("Stage", "lifecycleStage", {
      options: [["", "Set automatically"], ["lead", "Lead"], ["prospect", "Prospect"], ["customer", "Customer"]]
    }), this.field("Email", "email", {
      optional: true,
      type: "email"
    }), this.field("Phone", "phone", {
      optional: true,
      type: "tel"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "pcm-grid"
    }, this.field("Name", "name", {
      placeholder: "Business or person name",
      wide: true,
      autoFocus: !editing
    }), this.field("Customer number", "customerNumber", {
      optional: true
    }), this.field("Email", "email", {
      optional: true,
      type: "email"
    }), this.field("Phone", "phone", {
      optional: true,
      type: "tel"
    }), this.field("This is", "customerType", {
      options: [["business", "A business"], ["individual", "A person"]]
    }), this.field("Buys as", "lifecycleChannel", {
      options: [["b2b", "Business buyer"], ["b2c", "Shopper"]]
    }), this.field("Stage", "lifecycleStage", {
      options: [["", "Set automatically"], ["lead", "Lead"], ["prospect", "Prospect"], ["customer", "Customer"]]
    })), /*#__PURE__*/React.createElement("div", {
      className: "pcm-section"
    }, "Address"), /*#__PURE__*/React.createElement("div", {
      className: "pcm-grid three"
    }, this.field("City", "billToCity"), this.field("State or region", "billToRegion"), this.field("Postal code", "billToPostalCode")), /*#__PURE__*/React.createElement("label", {
      className: "pcm-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: s.sameShip,
      onChange: e => this.setState({
        sameShip: e.target.checked
      })
    }), /*#__PURE__*/React.createElement("span", null, "Ships to the same place")), !s.sameShip ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "pcm-section"
    }, "Ships to"), /*#__PURE__*/React.createElement("div", {
      className: "pcm-grid three"
    }, this.field("City", "shipToCity"), this.field("State or region", "shipToRegion"), this.field("Postal code", "shipToPostalCode"))) : null, s.error ? /*#__PURE__*/React.createElement("p", {
      className: "pcm-error",
      role: "alert"
    }, s.error) : null, /*#__PURE__*/React.createElement("div", {
      className: "pcm-foot"
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: s.saving,
      onClick: close
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: s.saving,
      onClick: this.save
    }, s.saving ? "Saving…" : editing ? "Save changes" : `Add ${noun}`))));
  }
}